class TestimonialsCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.track = this.querySelector('.testimonials__track');
    this.prevBtn = this.querySelector('[data-direction="prev"]');
    this.nextBtn = this.querySelector('[data-direction="next"]');
    this.dots = Array.from(this.querySelectorAll('.testimonials__dot'));
    this.currentIndex = 0;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.pauseAutoplay();
        this.scrollByCard(-1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.pauseAutoplay();
        this.scrollByCard(1);
      });
    }

    if (this.dots.length && this.track) {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.pauseAutoplay();
          const index = parseInt(dot.dataset.index, 10);
          this.scrollToCard(index);
        });
      });

      this.track.addEventListener('scroll', () => this.updateActiveDot(), { passive: true });
      this.updateActiveDot();
    }

    if (this.track) {
      this.track.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.track.addEventListener('mouseleave', () => this.resumeAutoplay());
      this.track.addEventListener('touchstart', () => this.pauseAutoplay(), { passive: true });
    }

    this.autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
    this.autoplayLoop = this.getAttribute('data-loop') === 'true';
    this.autoplaySpeed = parseInt(this.getAttribute('data-speed') || '4000', 10);

    if (this.autoplayEnabled) {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.pauseAutoplay();
  }

  getCards() {
    return this.track ? Array.from(this.track.querySelectorAll('.testimonials__card')) : [];
  }

  getGap() {
    if (!this.track) return 0;
    const style = getComputedStyle(this.track);
    const gap = style.columnGap || style.gap || '0';
    return parseFloat(gap) || 0;
  }

  scrollByCard(direction) {
    if (!this.track) return;
    const card = this.track.querySelector('.testimonials__card');
    if (!card) return;
    const cardWidth = card.getBoundingClientRect().width + this.getGap();
    this.track.scrollBy({ left: cardWidth * direction, behavior: 'smooth' });
  }

  scrollToCard(index) {
    const cards = this.getCards();
    const card = cards[index];
    if (!card || !this.track) return;
    const trackRect = this.track.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
    const offset = cardRect.left - trackRect.left + this.track.scrollLeft;
    this.track.scrollTo({ left: offset, behavior: 'smooth' });
  }

  updateActiveDot() {
    const cards = this.getCards();
    if (!cards.length || !this.track) return;

    const trackRect = this.track.getBoundingClientRect();
    let closestIndex = 0;
    let closestDistance = Infinity;

    cards.forEach((card, index) => {
      const cardRect = card.getBoundingClientRect();
      const distance = Math.abs(cardRect.left - trackRect.left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    this.currentIndex = closestIndex;

    if (this.dots.length) {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === closestIndex);
      });
    }
  }

  startAutoplay() {
    if (!this.track || this.autoplayTimer) return;
    const cards = this.getCards();
    if (cards.length < 2) return;

    this.autoplayTimer = setInterval(() => {
      const cardsNow = this.getCards();
      const isLast = this.currentIndex >= cardsNow.length - 1;

      if (isLast) {
        if (this.autoplayLoop) {
          this.scrollToCard(0);
        } else {
          this.pauseAutoplay();
        }
      } else {
        this.scrollByCard(1);
      }
    }, this.autoplaySpeed);
  }

  pauseAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  resumeAutoplay() {
    if (this.autoplayEnabled) {
      this.startAutoplay();
    }
  }
}

customElements.define('testimonials-carousel', TestimonialsCarousel);
